import { createReducer, on } from '@ngrx/store';
import * as SearchLocationsActions from './searchLocations.actions';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface CoordinatesState {
    latitude: number;
    longitude: number;
}

export interface SearchLocationsState {
    filters: {
        state: string;
        city: string;
        locationTypes: string[];
    };
    results: any[];
    markers: any[];
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialCoordinatesState: CoordinatesState = {
    latitude: null,
    longitude: null,
};

export const initialSearchLocationsState: SearchLocationsState = {
    filters: {
        state: '',
        city: '',
        locationTypes: [],
    },
    results: [],
    markers: [],
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// Coordinates Reducer
export const coordinatesReducer = createReducer(
    initialCoordinatesState,

    on(
        SearchLocationsActions.setCurrentMapCoordinates,
        (state, { latitude, longitude }) => ({
            ...state,
            latitude,
            longitude,
        })
    )
);

// Search Locations Reducer
export const searchLocationsReducer = createReducer(
    initialSearchLocationsState,

    // Set filters
    on(
        SearchLocationsActions.setSearchFilters,
        (state, { state: _state, city, locationTypes }) => ({
            ...state,
            filters: {
                state: _state,
                city,
                locationTypes,
            },
        })
    ),

    // Searching | Is Loading
    on(SearchLocationsActions.startSearchLocations, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        SearchLocationsActions.startSearchLocationsSuccess,
        (state, { results }) => ({
            ...state,
            isLoading: false,
            results,
        })
    ),
    on(
        SearchLocationsActions.startSearchLocationsError,
        (state, { error }) => ({
            ...state,
            isLoading: false,
            error: error,
        })
    ),

    // Clear
    on(SearchLocationsActions.clearPreviousSearchFilters, (state) => ({
        ...state,
        filters: {
            state: '',
            city: '',
            locationTypes: [],
        },
        results: [],
        markers: [],
    })),

    // Set Markers
    on(SearchLocationsActions.setMarkers, (state, { markers }) => ({
        ...state,
        markers,
    }))
);
